import { useState } from "react";
import Img from "./img.png";
import { sendProviderSMS } from "apiHandler/actions";
import Badge from "@mui/material/Badge";

const Input = (props) => {
  const [selectedFile, setSelectedFile] = useState([]);
  const [lengthData, setLengthData] = useState(0);
  const [text, setText] = useState("");
  const [imgData, setImgData] = useState();

  const userData = props.userData;
  const token = userData?.access_token;

  const changeHandler = (event) => {
    if (event.target.files.length) {
      const a = [...event.target.files];
      setSelectedFile(a);
      setLengthData(event.target.files.length);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    props.setShow(true);
    let payloadOne = {
      participant_number: props.provider_phone_mobile.toString(),
      author_name: userData.first_name + " " + userData.last_name,
      recipient_name: props.display_name,
      message_body: text,
    };

    let payloadTwo = {
      participant_number: props.provider_phone_mobile.toString(),
      author_name: userData.first_name + " " + userData.last_name,
      recipient_name: props.display_name,
    };

    const formData = new FormData();
    formData.append(
      "request_json",
      JSON.stringify(text.length ? payloadOne : payloadTwo)
    );

    if (imgData) {
      console.log("imgData-type", typeof imgData);
      console.log("imgData", imgData);
      console.log("selectedFile-type", typeof selectedFile);
      console.log("selectedFile under if-state", selectedFile);
      selectedFile.push(imgData);
    }

    console.log("selectedFile", selectedFile);

    selectedFile?.forEach((file) => {
      console.log("file", file);
      formData.append(`file`, file, file.name);
    });

    const response = await sendProviderSMS(formData, token);
    if (response) {
      setLengthData(0);
      setImgData(null);
      setText("");
      props.fetchMessages();
      props.setShow(false);
    }
  };

  const pasteImg = async () => {
    try {
      const clipboardItems = await navigator.clipboard.read();
      const blobOutput = await clipboardItems[0].getType("image/png");
      console.log("blobOutput-on paste", blobOutput);
      const data = URL.createObjectURL(blobOutput);
      setImgData(data);
    } catch (e) {
      console.log(e);
    }
  };

  const handleClick = () => {
    setImgData(null);
  };

  return (
    <div className="input">
      <input
        type="text"
        placeholder="Type Something..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        onPaste={pasteImg}
      />
      <div className="send">
        <input
          id="file"
          type="file"
          style={{ display: "none" }}
          onChange={changeHandler}
          disabled={!props.provider_phone_mobile}
          multiple
        />
        {lengthData ? (
          <span style={{ color: "#8da4f1" }}>
            {lengthData === 1 ? `${lengthData}` : `${lengthData}`}
          </span>
        ) : null}
        {imgData && (
          <div onClick={handleClick}>
            <Badge badgeContent="X" color="secondary">
              <img src={imgData} alt="" width="50px" height="50px" />
            </Badge>
          </div>
        )}

        <div style={{ backgroundColor: lengthData ? "gray" : "white" }}>
          <label htmlFor="file">
            <img src={Img} alt="" />
          </label>
        </div>
        <button onClick={onSubmit} disabled={!props.provider_phone_mobile}>
          Send
        </button>
      </div>
    </div>
  );
};

export default Input;
